import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "imaker-ico-expand",
  "use": "imaker-ico-expand-usage",
  "viewBox": "0 0 24.5 24.5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24.5 24.5\" id=\"imaker-ico-expand\">\n    <path stroke=\"#008099\" fill=\"none\" d=\"M6.999 12.999v-1h11v1h-11z\" />\n    <path stroke=\"#008099\" fill=\"none\" d=\"M11.999 6.999h1v11h-1v-11z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol